export enum LoginAccountType {

    CFD = 1,
    Invest = 2
}
